import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _42fc34f6 = () => interopDefault(import('../../../pages/agenzia-di-comunicazione.vue' /* webpackChunkName: "pages/agenzia-di-comunicazione" */))
const _b3f3b4b8 = () => interopDefault(import('../../../pages/contatti.vue' /* webpackChunkName: "pages/contatti" */))
const _e4a8d46a = () => interopDefault(import('../../../pages/progetti/index.vue' /* webpackChunkName: "pages/progetti/index" */))
const _bc4ce2ac = () => interopDefault(import('../../../pages/progetti/categoria/_slug/index.vue' /* webpackChunkName: "pages/progetti/categoria/_slug/index" */))
const _c608c4a4 = () => interopDefault(import('../../../pages/progetti/cliente/_slug.vue' /* webpackChunkName: "pages/progetti/cliente/_slug" */))
const _59a1c780 = () => interopDefault(import('../../../pages/progetti/page/_num.vue' /* webpackChunkName: "pages/progetti/page/_num" */))
const _029042ac = () => interopDefault(import('../../../pages/progetti/categoria/_slug/page/index.vue' /* webpackChunkName: "pages/progetti/categoria/_slug/page/index" */))
const _8830e4c2 = () => interopDefault(import('../../../pages/progetti/categoria/_slug/page/_num.vue' /* webpackChunkName: "pages/progetti/categoria/_slug/page/_num" */))
const _e81616fa = () => interopDefault(import('../../../pages/progetti/_slug.vue' /* webpackChunkName: "pages/progetti/_slug" */))
const _21304c23 = () => interopDefault(import('../../../pages/servizi/_slug.vue' /* webpackChunkName: "pages/servizi/_slug" */))
const _f971f090 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/agenzia-di-comunicazione",
    component: _42fc34f6,
    name: "agenzia-di-comunicazione"
  }, {
    path: "/contatti",
    component: _b3f3b4b8,
    name: "contatti"
  }, {
    path: "/progetti",
    component: _e4a8d46a,
    name: "progetti"
  }, {
    path: "/progetti/categoria/:slug",
    component: _bc4ce2ac,
    name: "progetti-categoria-slug"
  }, {
    path: "/progetti/cliente/:slug?",
    component: _c608c4a4,
    name: "progetti-cliente-slug"
  }, {
    path: "/progetti/page/:num?",
    component: _59a1c780,
    name: "progetti-page-num"
  }, {
    path: "/progetti/categoria/:slug?/page",
    component: _029042ac,
    name: "progetti-categoria-slug-page"
  }, {
    path: "/progetti/categoria/:slug?/page/:num",
    component: _8830e4c2,
    name: "progetti-categoria-slug-page-num"
  }, {
    path: "/progetti/:slug",
    component: _e81616fa,
    name: "progetti-slug"
  }, {
    path: "/servizi/:slug?",
    component: _21304c23,
    name: "servizi-slug"
  }, {
    path: "/",
    component: _f971f090,
    name: "index"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
